export enum LodashSortingType {
  DESC = "desc",
  ASC = "asc",
}
